export default __webpack_public_path__ + "static/map-1ebe84f6dc5af852cbe43e2a449b6511.svg";